import { render, staticRenderFns } from "./InquiryRequestListItem.vue?vue&type=template&id=c4d6d236&scoped=true"
import script from "./InquiryRequestListItem.vue?vue&type=script&lang=ts"
export * from "./InquiryRequestListItem.vue?vue&type=script&lang=ts"
import style0 from "./InquiryRequestListItem.vue?vue&type=style&index=0&id=c4d6d236&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d6d236",
  null
  
)

export default component.exports